export default __webpack_public_path__ + "static/media/ae12.7c0e020a.jpg";